export default "__VITE_ASSET__CloQ5W8A__"